/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAppThemes} from '../api'

 export const useQueryGetAppThemes = createReactQueryHook('getAppThemes', getAppThemes)
